import react, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";

import moment from "moment";
import Link from "./Link";

const useStyles = makeStyles((theme) => ({
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cardRootFlex: {
    flexGrow: 1,
  },
  title: {
    fontSize: 17,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "& a:hover": {
      textDecoration: "none",
    },
  },
  author: {
    "& a": {
      color: "inherit",
    },
    "& a:hover": {
      textDecoration: "none",
    },
  },
  thumb: {
    "& img": {
      maxWidth: "100%",
    },
  },
}));

const VideoAlt = (props) => {
  const { video, flex } = props;

  console.log("TEST");

  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={5}>
        <Link
          href={`/video/${video.meta.id}`}
          className={classes.thumb}
          component="a"
        >
          <img
            src={
              video.meta && video.meta.thumbnail && video.meta.thumbnail !== ""
                ? video.meta.thumbnail
                : `https://image.mux.com/${video.video_asset.playback_ids[0].id}/thumbnail.jpg`
            }
          />
        </Link>
      </Grid>
      <Grid item xs={7}>
        <Typography variant="h6" component="h2" className={classes.title}>
          <Link href={`/video/${video.meta.id}`} component="a">
            {video.meta.title || "No Post Title"}
          </Link>
        </Typography>
        <Typography
          component="div"
          variant="caption"
          color="textSecondary"
          className={classes.author}
        >
          <Link href={`/profile/${video.meta.authorName}`}>
            {video.meta.authorName}
          </Link>
        </Typography>
        <Typography component="div" variant="caption" color="textSecondary">
          {`${video.meta.views || 0} ${
            video.meta.views === 1 ? `view` : `views`
          } - ${moment(video.meta.created.toDate()).fromNow()}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default VideoAlt;
